import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const WordForm = ({ data = {}, onUpdate = () => {} }) => {

  // Ensure items array exists
  const items = data?.items || [{ id: 1, desc: "", qty: 1, rate: 0, amount: 0 }];

  return (
    <div className="space-y-4">

      <h3 className="font-bold text-lg text-[#1E3A8A] border-b pb-2 uppercase tracking-wide">Corporate Details</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Invoice #" 
          value={data?.invoiceNumber || ""} 
          onChange={(v) => onUpdate("invoiceNumber", v)} 
          required 
        />
        <InvoiceField 
          label="Invoice Date" 
          type="date" 
          value={data?.date || ""} 
          onChange={(v) => onUpdate("date", v)} 
        />
      </div>

      <InvoiceField 
        label="Company Name" 
        type="string"
        value={data?.companyName || ""} 
        onChange={(v) => onUpdate("companyName", v)} 
        required
      />

      <InvoiceField 
        label="Company Address" 
        type="description" 
        value={data?.companyAddress || ""} 
        onChange={(v) => onUpdate("companyAddress", v)} 
        rows="2"
      />

      <InvoiceField 
        label="Company GSTIN" 
        type="string" 
        value={data?.companyGSTIN || ""} 
        onChange={(v) => onUpdate("companyGSTIN", v)} 
      />

      <div className="pt-4 border-t">
        <h4 className="text-xs font-bold text-gray-400 mb-3 uppercase">Billing Information</h4>

        <InvoiceField 
          label="Client Name" 
          value={data?.clientName || ""} 
          onChange={(v) => onUpdate("clientName", v)} 
          required 
        />
        <InvoiceField 
          label="Client Address" 
          type="description" 
          value={data?.clientAddress || ""} 
          onChange={(v) => onUpdate("clientAddress", v)} 
          rows="2"
        />
      </div>

      {/* Items Section */}
      <div className="pt-4 border-t">
        <h4 className="text-xs font-bold text-gray-400 mb-3 uppercase">Items / Services</h4>
        {items.map((item, idx) => (
          <div key={idx} className="grid grid-cols-5 gap-2 mb-2 items-end">
            <InvoiceField 
              label="Description" 
              value={item.desc} 
              onChange={(v) => onUpdate(`items[${idx}].desc`, v)} 
              required
            />
            <InvoiceField 
              label="Qty" 
              type="number" 
              value={item.qty} 
              onChange={(v) => onUpdate(`items[${idx}].qty`, parseFloat(v))} 
            />
            <InvoiceField 
              label="Rate (₹)" 
              type="number" 
              value={item.rate} 
              onChange={(v) => onUpdate(`items[${idx}].rate`, parseFloat(v))} 
            />
            <InvoiceField 
              label="Amount (₹)" 
              type="number" 
              value={item.amount} 
              onChange={(v) => onUpdate(`items[${idx}].amount`, parseFloat(v))} 
              disabled
            />
            <button 
              type="button" 
              className="text-red-500 font-bold mt-1"
              onClick={() => onUpdate("items", items.filter((_, i) => i !== idx))}
            >
              Remove
            </button>
          </div>
        ))}
        <button 
          type="button" 
          className="mt-2 px-2 py-1 bg-blue-600 text-white rounded text-xs"
          onClick={() => onUpdate("items", [...items, { id: items.length + 1, desc: "", qty: 1, rate: 0, amount: 0 }])}
        >
          Add Item
        </button>
      </div>

      {/* GST and Totals */}
      <div className="pt-4 border-t grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Tax Rate (%)" 
          type="number" 
          value={data?.taxRate || 0} 
          onChange={(v) => onUpdate("taxRate", parseFloat(v))} 
        />
        <InvoiceField 
          label="Total Amount (₹)" 
          type="number" 
          value={data?.total || 0} 
          onChange={(v) => onUpdate("total", parseFloat(v))} 
          disabled
        />
      </div>

      {/* Save Button */}
      <div className="pt-4 border-t">
        <button 
          type="button" 
          className="px-4 py-2 bg-green-600 text-white rounded"
          onClick={() => {
            // Save to localStorage for now
            localStorage.setItem("wordInvoiceData", JSON.stringify(data));
            alert("Invoice saved locally!");
          }}
        >
          Save Invoice
        </button>
      </div>
    </div>
  );
};

export default WordForm;
